
/* injects from baggage-loader */

/*
 * api Lesson service
 */

const moduleLesson = angular.module('api.lesson', []);

moduleLesson.factory('Lesson', [
  "Restangular", "$rootScope", "$stateParams", "$state", "$modal", "$injector",
  (Restangular, $rootScope, $stateParams, $state, $modal, $injector) => {
    return {
      _currentSite: Restangular.one('lms_pages', $stateParams.lessonId),
      get: (id) => {
        if (id) {
          return Restangular.one('lms_pages', id).get();
        } else {
          return Restangular.one('lms_pages', $stateParams.lessonId).get();
        }
      },
      getList: () => {
        return Restangular.all('lms_pages').getList();
      },
      update: (site) => {
        return Restangular.all('lms_pages').one(site.id).customPUT(site);
      },
      updateByRoute: (site) => {
        return Restangular.all('lms_pages').one($stateParams.lessonId).customPUT(site);
      },
      remove: (id) => {
        return Restangular.one('lms_pages', id).remove();
      },
      create: (site) => {
        return Restangular.all('lms_pages').post(site);
      },
      saveIndex: (changes) => {
        return Restangular.one('lms_pages', $stateParams.lessonId).all('assets/save').post({
          changes: changes,
          path: $rootScope.currentFile.full_path
        });
      },
      transfer: (data) => {
        return Restangular.one('lms_pages', $stateParams.lessonId).all("transfer").post(data);
      },
      share: (site) => {
        return Restangular.one('lms_pages', $stateParams.lessonId).all("share").post(site);
      },
      setTemplate: (template_id) => {
        return Restangular.all("lms_pages").one($state.params.lessonId).customPUT({
          template_id: template_id
        });
      },
      createTemplate: (templateParams) => {
        return Restangular.all("lms_pages").one($state.params.lessonId).all("templates").post(templateParams);
      },
      addSite: () => {
        return $state.go("root.new_site");
      },
      publish: () => {
        return Restangular.all("lms_pages").one($state.params.lessonId).all("build").post();
      },
      clone: (site_id) => {
        return Restangular.all("lms_pages").one(site_id).all("clone").post();
      },
      goToSite: (siteSlug) => {
        if ($stateParams.lessonId) {
          if (!$state.includes("public.templates") && !$state.includes("lesson.page.editor")) {
            const newstate = _.extend($state.params, {lessonId: siteSlug});
            return $state.transitionTo($state.current, newstate, {reload: true});
          } else {
            return $state.go('root.site.requests.bystatus', {lessonId: siteSlug, status: "inbox"});
          }
        } else {
          return $state.go('root.site.requests.bystatus', {lessonId: siteSlug, status: "inbox"});
        }
      },
      /**
       * Загрузка кастомных стилей из lms
       */
      getLmsStylesheets:() => {
        const serviceDomain = window.justclick.serviceDomain;

        return Restangular.oneUrl('styles', `${serviceDomain}/sites/constructor/stylesheets`).get();
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/api/lesson.js